import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton',
  template: `
    <div [style.width]="width"
         [style.height]="height"
         [style.border-radius]="radius"
         [class.skeleton-dark]="darkMode"
         class="skeleton-shimmer"></div>
  `,
  styles: [`
    .skeleton-shimmer {
      display: block;
      background: linear-gradient(90deg, #e0e0e0 25%, #efefef 50%, #e0e0e0 75%);
      background-size: 200% 100%;
      animation: shimmer 1.4s infinite linear;
    }
    .skeleton-shimmer.skeleton-dark {
      background: linear-gradient(90deg, #2c2c2c 25%, #3a3a3a 50%, #2c2c2c 75%);
      background-size: 200% 100%;
    }
    @keyframes shimmer {
      0%   { background-position: 200% 0; }
      100% { background-position: -200% 0; }
    }
  `],
})
export class SkeletonComponent {
  @Input() width  = '100%';
  @Input() height = '1rem';
  @Input() radius = '4px';
  @Input() darkMode = false;
}
